"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VersionText = exports.InformationLink = exports.InformationText = exports.ContentWrapper = exports.FooterWrapper = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const colors_1 = require("../../../theme/colors");
exports.FooterWrapper = styled_components_1.default.div `
  height: 128px;
  width: 100%;
  background-color: ${colors_1.WHITE};
  @media (max-width: 687px) {
    height: 100%;
  }
`;
exports.ContentWrapper = styled_components_1.default.div `
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100%;
  border: 1px solid ${colors_1.GREY1};
  padding: 0 64px;
  @media (max-width: 687px) {
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 8px;
  }
`;
exports.InformationText = styled_components_1.default.div `
  color: ${colors_1.GREY3};
  font-weight: 700;
  margin: 0 32px;
  @media (max-width: 687px) {
    text-align: center;
  }
`;
exports.InformationLink = styled_components_1.default.a `
  color: ${colors_1.SWEGON_GREEN};
  margin-left: 4px;
  text-decoration: none;
`;
exports.VersionText = styled_components_1.default.p `
  color: ${colors_1.GREY3};
  font-weight: 400;
  font-size: 13px;
  text-align: right;
  margin: 8px 0 0;
  @media (max-width: 687px) {
    text-align: center;
  }
`;
//# sourceMappingURL=Footer.styles.js.map